module.exports = __webpack_public_path__ + "img/altramuces.4a9710a4.png";